import styled from "styled-components";
import { Link } from "react-router-dom";
import { primaryColor, topBarHeight } from "../../config/constants";

export const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  width: 100%;
`;
export const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-shrink: 0;
  /* El primer elemento del menu arranca justo donde acaba la barra superior. */
  padding: ${topBarHeight} 0 25px;
  width: 256px;
  background-color: #fff;
`;
export const MenuSection = styled.div`
  display: flex;
  flex-direction: column;
`;
// Comparten aspecto el enlace de navegacion, el boton de logout y el enlace
// externo, que en HTML son tres elementos distintos.
const menuItemStyles = `
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 15px;
  width: 100%;
  height: 48px;
  border: none;
  font-size: 13px;
  font-family: inherit;
  text-align: left;
  text-decoration: none;
  background: none;
  outline: none;
  cursor: pointer;
`;
export const MenuLink = styled(Link)`
  ${menuItemStyles}
  color: ${({ $isActive }) => ($isActive ? "#fff" : "#555")};
  background-color: ${({ $isActive }) => ($isActive ? primaryColor : "transparent")};
  &:hover {
    background-color: ${({ $isActive }) => ($isActive ? primaryColor : "#f5f5f5")};
  }
`;
export const MenuButton = styled.button`
  ${menuItemStyles}
  color: #555;
  &:hover {
    background-color: #f5f5f5;
  }
`;
export const MenuExternalLink = styled.a`
  ${menuItemStyles}
  color: ${primaryColor};
  &:hover {
    background-color: #f5f5f5;
  }
`;
export const MenuIcon = styled.img`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  object-fit: contain;
`;
export const MainColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;
  background-color: #eeeeee;
`;
export const MainContent = styled.div`
  margin: 0 auto;
  padding: 25px 20px 50px;
  width: 100%;
  max-width: 900px;
`;
